const getFormattedDate = (date: Date): string => {
  return date.toISOString().slice(0, 10);
};

export const getTodayDate = (): string => {
  return getFormattedDate(new Date());
};

export const getTomorrowDate = (): string => {
  return getFutureDate(1);
};

export const getFutureDate = (days: number): string => {
  const futureDate = new Date();
  futureDate.setDate(futureDate.getDate() + days);
  return getFormattedDate(futureDate);
};
